import { render, staticRenderFns } from "./assignment-request-pdf-viewer.vue?vue&type=template&id=7205d154"
import script from "./assignment-request-pdf-viewer.vue?vue&type=script&lang=js"
export * from "./assignment-request-pdf-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports